import { render } from "./FAQWorkPlan.vue?vue&type=template&id=716709b3"
import script from "./FAQWorkPlan.vue?vue&type=script&lang=js"
export * from "./FAQWorkPlan.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__